import styles from './footer.module.css'
import { Separator, Logo } from '../../components'

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.contact}>
        <div>
          <h1>Ubicación</h1>
          <Separator color='#fff' />
        </div>

        <p>Avenida Andrômeda, 2000. Bloco 6 e 8 </p>
        <p>Alphavile SP</p>
        <p>brasil@corebiz.ag</p>
        <p>+55 11 3090 1039</p>
      </div>

      <div className={styles.buttons}>
        <button>
          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22.736 17.388'>
            <path d='M20.464,17.388H2.273A2.227,2.227,0,0,1,0,15.214L.011,2.174A2.222,2.222,0,0,1,2.273,0H20.464a2.227,2.227,0,0,1,2.273,2.174v13.04A2.227,2.227,0,0,1,20.464,17.388ZM2.273,2.174V4.347l9.1,5.434,9.1-5.434V2.174l-9.1,5.434-9.1-5.434Z' />
          </svg>
          <h3>CONTÁCTANOS</h3>
        </button>
        <button>
          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22.737 26.75'>
            <path d='M11.369,0A11.163,11.163,0,0,0,0,10.943v8.511A3.716,3.716,0,0,0,3.79,23.1h3.79V13.375H2.526V10.943a8.675,8.675,0,0,1,8.842-8.511,8.675,8.675,0,0,1,8.842,8.511v2.432H15.158V23.1h5.053v1.216H11.369V26.75h7.579a3.716,3.716,0,0,0,3.79-3.648V10.943A11.163,11.163,0,0,0,11.369,0Z' />
          </svg>
          <h3>HABLA CON UN CONSULTOR</h3>
        </button>
      </div>

      <div className={styles.bottom}>
        <div>
          <p>Desarrollado por</p>
          <Logo />
        </div>
        <div>
          <p>Powered by</p>
          <svg viewBox='0 0 170 70' xmlns='http://www.w3.org/2000/svg'>
            <path d='M13.7 9.79995C11.5 12.2999 11.6 13.2 14.5 19L17 24H13.8C9.1 24 6.6 23.5999 6 25.2999C5.7 26.0999 8.9 35.3 13.6 44.1C21 57.8 22.6 60.1 24.4 59.8C25.6 59.6 27.3 58 28.5 55.8C29.6 53.7 30.8 52 31.2 52C31.6 52 33.1 54 34.5 56.4C37.8 62.1 39.4 63.4 42.4 62.6C44.4 62.1 47.1 57.9 55.8 41.7C72.3 11.3 72.9 10.9 71 7.99995H68H41.6C17.4 7.99995 15.2 8.09995 13.7 9.79995ZM43.7 25.2999C45 26.5999 33.5 47.5 31.4 47.5C30.3 47.5 27.9 44.1 24.4 37.6C18.5 26.8 18.1 25.3999 20.8 24.5999C23.6 23.7999 42.8 24.3999 43.7 25.2999Z' />
            <path d='M76.6 24.8C75.9 26 80.7 42.8 82.6 45.7C84.2 48.3 89.1 48.9 90.7 46.7C91.7 45.5 97 27.3 97 25.2C97 23.6 93.5 23.7 92.3 25.2C91.7 25.9 90.5 29.6 89.5 33.5C88.5 37.3 87.4 40.9 87 41.3C86.6 41.8 85.2 38.2 83.9 33.3C81.9 26 81.1 24.4 79.3 24.2C78.2 24 76.9 24.3 76.6 24.8Z' />
            <path d='M100.4 25.5C99.5 27.7 100.8 29 104.1 29H107V38.5C107 48 107 48 109.5 48C112 48 112 48 112 38.5V29H115C117.5 29 118 28.6 118 26.5C118 24 117.9 24 109.5 24C102.9 24 100.8 24.3 100.4 25.5Z' />
            <path d='M123.1 25.9C121.3 27.7 121 29.3 121 36.3C121 46.7 122 48 130.3 48C135.3 48 136 47.8 136 46.1C136 44.5 135.2 44.1 131.8 43.8C127.9 43.5 127.5 43.2 127.2 40.7C126.9 38.1 127 38 131.4 38C135.3 38 136 37.7 136 36C136 34.3 135.3 34 131.5 34C127.4 34 127 33.8 127 31.6C127 29.4 127.5 29.1 131.3 28.8C134.7 28.6 135.5 28.1 135.5 26.5C135.5 24.8 134.7 24.5 130.3 24.2C126.1 24 124.7 24.3 123.1 25.9Z' />
            <path d='M140 25.1C140 25.7 141.4 28.1 143 30.5C144.7 32.9 146 35.3 146 35.9C146 36.5 144.7 39.2 143 41.8C139.4 47.7 139.4 48 142.4 48C144 48 145.6 46.9 147 45C149.7 41.2 150.6 41.2 152.5 45C153.7 47.3 154.7 48 157 48C158.7 48 160 47.6 160 47.2C160 46.8 158.7 44.3 157 41.7C155.4 39.1 154 36.4 154 35.7C154 35 155.4 32.5 157 30C160.6 24.6 160.7 24 157.8 24C156.4 24 154.4 25.3 152.8 27.2L150 30.5L147.4 27.2C144.9 24.1 140 22.7 140 25.1Z' />
          </svg>
        </div>
      </div>
    </footer>
  )
}

export default Footer
